export const getDisplayedDrugName = (
  drugName: string,
  strength?: string,
  strengthUnitOfMeasure?: string,
  dosageForm?: string,
) => {
  return `${drugName} ${strength || ''} ${strengthUnitOfMeasure || ''} ${dosageForm || ''}`.trim()
}
